module.exports = __webpack_public_path__ + "img/winerackdog48.dd86b574.jpg";